import React, { useContext, useState, useEffect } from 'react'
import ReactGA from 'react-ga'
import { useHistory } from 'react-router-dom'
import { FaCheck } from 'react-icons/fa'
import { SwipeableList, SwipeableListItem, SwipeAction, TrailingActions } from 'react-swipeable-list'
import 'react-swipeable-list/dist/styles.css'

import * as S from './styles'
import { Container } from '../../../styles/global'
import { ActionContent, ItemColumnCentered } from '../../../styles/swipeableList'
import SolicitationCard from '../../../components/SolicitationCard'

import _ from 'lodash'
import Swal from 'sweetalert2'
import { RootContext } from '../../../context/rootContext'

import { updateSolicitation } from '../../../services/solicitations'

const SolicitationsView = () => {
  const history = useHistory()
  const { globalState, handleUpdateSolicitation } = useContext(RootContext)
  const [state] = globalState
  const [solicitationsList, setSolicitationsList] = useState([])

  useEffect(() => {
    setSolicitationsList(state.solicitationsList.filter(solicitation => !solicitation.answerRead))
  }, [state])

  const goToPage = (url) => {
    history.push(`/${url}`)
    ReactGA.pageview(`/${url}`)
  }

  const handleReadSolicitation = async id => {
    const response = await updateSolicitation(id, {
      answerRead: true
    })

    const responseData = response.data

    if (responseData) {
      handleUpdateSolicitation(id, responseData)
    } else {
      Swal.fire({
        title: '<h3 style=\'color: #000; font-size: 24px; font-weight: 700; font-family: "Nunito"\'>Erro!</h3>',
        html: '<p style="color: #000;">Não foi possível enviar sua solicitação, tente novamente</p>',
        icon: 'error',
        showCancelButton: false,
        showConfirmButton: false,
        background: '#fff'
      })
    }
  }

  const trailingActions = ({ id }) => (
    <TrailingActions>
      <SwipeAction destructive={true} onClick={() => handleReadSolicitation(id)}>
        <ActionContent padding='16px' backgroundColor='#009CA6'>
          <ItemColumnCentered>
            <FaCheck color='#fff' size='14' />
            <span>lido</span>
          </ItemColumnCentered>
        </ActionContent>
      </SwipeAction>
    </TrailingActions>
  )

  const solicitations = _.partition(solicitationsList,
    (solicitation) => !!solicitation.answerMessage
  )

  return (
    <Container>
      <S.SolicitationButton onClick={() => goToPage('new-agenda-block')}>Novo bloqueio de agenda</S.SolicitationButton>
      <S.SolicitationButton outline onClick={() => goToPage('new-scheduling')}>Novo agendamento ou encaixe</S.SolicitationButton>
      <S.SolicitationList>
        <S.SolicitationTitle>Respostas</S.SolicitationTitle>
        <SwipeableList>
          {solicitations[0].map(solicitation => (
            <SwipeableListItem
              key={solicitation.id}
              trailingActions={trailingActions(solicitation)}
            >
              <SolicitationCard solicitationData={solicitation} />
            </SwipeableListItem>
          ))}
        </SwipeableList>
      </S.SolicitationList>
      <S.SolicitationList>
        <S.SolicitationTitle>Solicitações pendentes</S.SolicitationTitle>
        {solicitations[1].map(solicitation => (
          <SolicitationCard solicitationData={solicitation} key={solicitation.id} />
        ))}
      </S.SolicitationList>
      <S.SolicitationButton outline onClick={() => goToPage('solicitations-history')}>Histórico de solicitações</S.SolicitationButton>
    </Container>
  )
}

export default SolicitationsView
